import DatePicker, { registerLocale } from "react-datepicker";

import dayjs from "dayjs";

export default function Calendar({
    datesEventsHappening,
    selectedFilters,
    setSelectedFilters,
}) {

    const specialDates = datesEventsHappening;

    let selectedDate;

    /**
     *  Handler: User selects a date in the calendar.
     */
    const onChangeHandler = (date) => {
        let filterVals = {
            ...selectedFilters,
            cal_sel_dates: [date],
            is_filtered: true,
        };

        setSelectedFilters(filterVals);
    };

    const getDayClassName = (date) => {
        const formattedDate = dayjs(date).format("YYYY-MM-DD");

        const specialDatesFormatted = specialDates.map((d) =>
            dayjs(d).format("YYYY-MM-DD"),
        );

        return specialDatesFormatted.includes(formattedDate)
            ? "event-happening"
            : undefined;
    };

    const excludeNoEventDates = (date) => {
        const formattedDate = dayjs(date).format("YYYY-MM-DD");

        const specialDatesFormatted = specialDates.map((d) =>
            dayjs(d).format("YYYY-MM-DD"),
        );

        return specialDatesFormatted.includes(formattedDate);
    };

    if (selectedFilters.cal_sel_dates?.length == 1) {
        selectedDate = selectedFilters.cal_sel_dates[0];
    } else {
        selectedDate = new Date();
    }

    return (
        <div className="calendar wrapper">
            <DatePicker
                minDate={new Date()} // Disable past dates
                selected={selectedDate}

                // Actions.
                onChange={onChangeHandler}
                dayClassName={getDayClassName}
                filterDate={excludeNoEventDates}

                // Settings.
                useWeekdaysShort={true} // Show days header: Mon, Tue. etc
                monthsShown={1}
                closeOnScroll={true}
                shouldCloseOnSelect={true}
                wrapperClassName="calendar wrapper"
                inline
            />
        </div>
    );
}
